import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment";
import axios from "axios";
import { baseURL } from "../../services/api";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useNavigate, useParams } from "react-router";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import { formatNumber, isNumeric } from "../../helpers/formater";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";

const InvoiceDepenseDetails = (props) => {
  const { id } = useParams();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [t, i18n] = useTranslation();

  const [invoice, setInvoice] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState("");
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [spentAccounts, setSpentAccounts] = useState([]);
  const [invoiceId, setInvoiceId] = useState("");
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);
  const [invoiceStatusHistory, setInvoiceStatusHistory] = useState([]);

  const [invoiceNumber, setInvoiceNumber] = useState("");

  useEffect(() => {
    getInvoiceData();
    getInvoiceSpentAccount();
    getInvoiceStatusHistory();
  }, []);
  const getInvoiceStatusHistory = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/invoice_depense_status_history/${id}`)
      .then((response) => {
        setInvoiceStatusHistory(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error)
      );
  };
  const getInvoiceSpentAccount = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/facture_depense_spent_accounts/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          setSpentAccounts(response.data.data);
          console.log("setInvoiceProductsState: ", response.data.data);
        }
      })
      .catch((error) => console.log("error " + error));
  };
  const setData = (invoice) => {
    setInvoiceId(`Fact-depense-${formatNumber(invoice.id)}`);
    setSummaryTotatlHt(invoice.total_ht);
    setInvoiceDueDate(invoice.due_date);
    setInvoiceCreatedAt(invoice.created_at);
    setSummaryTotatlTtc(invoice.total_ttc);
    setSummaryTotalTva(invoice.total_tva);
    setInvoiceNumber(invoice.invoice_number);
  };
  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = { value: target[i].id, label: target[i].companyName };
      array.push(obj);
    }
    return array;
  };
  const getInvoiceData = async () => {
    let fst = {};
    let snd = {};
    let res_suppliers_response = {};
    let res_purchaseAccount_response = {};
    let res = {};
    let suppliers_response = {};
    let purchaseAccount_response = {};

    const response2 = await jwtInterceoptor
      .get(`/data/user/factures_depense/byid/${id}`)
      .then((res) => {
        snd = res.data.data;

        setInvoice(res.data.data);
        setData(res.data.data);
      })
      .catch((error) => console.log(error));

    const response3 = await axios
      .get(
        baseURL + `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`
      )
      .then((res) => {
        console.log("data ", res.data.data);
        setSuppliers(transformArrayToOptions(res.data.data));
        suppliers_response = transformArrayToOptions(res.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error)
      );

    res_suppliers_response = suppliers_response.filter(
      (s) => s.value === snd.supplier_id
    );

    setSupplier({
      value: res_suppliers_response[0]["value"],
      label: res_suppliers_response[0]["label"],
    });
  };

  const downloadPJ = async () => {
    try {
      const response = await jwtInterceoptor.get(
        `/data/download/factures_depense/${id}`,
        { responseType: "arraybuffer" }
      );
      if (response.status === 200) {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Piéce facture depense no-${formatNumber(id)}`;
        link.click();
      } else {
        Swal.fire(
          t("Oops"),
          t("Une erreur s'est produite, réessayez"),
          "error"
        );
      }
    } catch (e) {
      Swal.fire(t("Oops"), t("le fichier n'existe pas"), "error");
    }
  };
  const [selectedFile, setSelectedFile] = useState(null);
    // Fonction pour gérer la sélection du fichier
    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
    };
      // Fonction pour envoyer le fichier au backend
  const handleSubmit = async (idpai) => {
    if (!selectedFile) {
      toast.error("Veuillez sélectionner un fichier");
      return;
    }

    const formData = new FormData();
    formData.append("recu", selectedFile); 

    try {
      const response = await jwtInterceoptor.post(
        baseURL + `/data/importer/factureDepense/${idpai}`, 
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", 
          },
        }
      );

      if (response.status === 200) {
        toast.success("Reçu a été importer avec succès !");
        setSelectedFile();
      } else {
        toast.error("Erreur lors de l'importation");
      }
    } catch (error) {
      console.error("Erreur:", error);
      toast.error("Erreur lors de l'importation");
    }
  };
    //// la fonction de dowland Recu 
    const downloadRecu = async (idPaiement) => {
      try {
        const response = await jwtInterceoptor.get(
          baseURL + `/data/download/factureDepense/${idPaiement}`, {
          responseType: 'blob', // important to get the file in binary format
        });
    
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `recu_${idPaiement}.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
    
        toast.success("Reçu a été télécharger avec succès !");
      } catch (error) {
        console.error("Erreur lors du téléchargement du reçu:", error);
        toast.error("Erreur lors du téléchargement du reçu");
      }
    };


  return (
    <>
          <ToastContainer />
      <div className="container-fluid">
        <div className="row" style={{ zIndex: 1 }}>
          <div className="col-lg-12">
            <div class="page-header">
              <h1 class="page-title">{t("Détail de la facture")}</h1>
              <div>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => navigate("/depense/facturedepense/list")}
                    >
                      {/* Correction de la faute d’orthographe */}
                      liste des factures de dépenses
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    details
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div className="col-xl-8 col-md-12 card">
            <div className="card-body" style={{ overflowX: "auto" }}>
              <div class="col-xl-12">
                <div class="panel panel-primary">
                  <div class="panel-body tabs-menu-body">
                    <div class="tab-content">
                      <div class="tab-pane active">
                        <div className="row">
                          <div className="col-md-6"></div>
                          <div className="col-md-6">
                            <label htmlFor="exampleInputEmail1" className="">
                              Facture no:
                            </label>
                            <input
                              type={"text"}
                              disabled={true}
                              className="form-control"
                              value={
                                isNumeric(invoiceNumber)
                                  ? `Fact-depense-${formatNumber(
                                      invoiceNumber
                                    )}`
                                  : invoiceNumber
                              }
                            />
                          </div>
                        </div>
                        <br />
                        <br />
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                fournisseur
                              </label>
                              <Select
                                value={supplier}
                                onChange={(choice) => setSupplier(choice)}
                                isDisabled={true}
                              />
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                date d'échéance
                              </label>
                              <input
                                type="date"
                                placeholder="nom"
                                className={`form-control `}
                                onChange={(e) =>
                                  setInvoiceDueDate(e.target.value)
                                }
                                value={invoiceDueDate}
                                disabled={true}
                              />
                            </div>
                          </div> 
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                date de facture
                              </label>
                              <input
                                type="text"
                                placeholder="nom"
                                className={`form-control `}
                                onChange={(e) =>
                                  setInvoiceCreatedAt(e.target.value)
                                }
                                value={moment(invoiceCreatedAt).format(
                                  "YYYY-MM-DD"
                                )}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>

                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">DESIGNATION</th>
                              <th scope="col">COMPTE DE DÉPENSES</th>
                              <th scope="col">TAXE</th>
                              <th scope="col">Total HT</th>
                              <th scope="col">Total TTC</th>
                            </tr>
                          </thead>

                          {spentAccounts.map((accounts) => {
                            return (
                              <tr key={accounts.id}>
                                <td>{accounts.designation}</td>
                                <td>
                                  {accounts.account.name +
                                    " - " +
                                    accounts.account.code}
                                </td>
                                <td>{accounts.tva.name}</td>
                                <td>{Number(accounts.total_ht).toFixed(2)}</td>
                                <td>{Number(accounts.total_ttc).toFixed(2)}</td>
                              </tr>
                            );
                          })}
                        </table>

                        <div className="d-flex flex-row-reverse">
                          <div className="invoiceSummary">
                            <table>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total HT :
                                </td>
                                <td>
                                  {Number(summaryTotatlHt).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total TVA :
                                </td>
                                <td>
                                  {Number(summaryTotalTva).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total TTC :
                                </td>
                                <td>
                                  {Number(summaryTotatlTtc).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6"></div>
                          <div className="col-6 d-flex flex-row-reverse">
                            <button
                              onClick={downloadPJ}
                              className="btn btn-sm" style={{backgroundColor:"#f1461d", color:"white"}}
                            >
                              <i className="fe fe-download"></i> Télécharger la
                              Pièce
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-12">
            <div class="tab-pane">
              <div className="">
                <div class="container">
                  <ul class="notification">
                    {invoiceStatusHistory.map((invoiceStatus) => {
                      if (invoiceStatus.status.name === "Payé en partie") {
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                    <p class="mb-0 fs-13 text-dark">
                                      {"Mantant Payé: " +
                                        Number(invoiceStatus.payed_amount).toFixed(2) +
                                        organisation?.currency?.code}
                                    </p>
                                    <p class="mb-0 fs-13 text-dark">
                                      {"Réste à payé: " +
                                        Number(invoiceStatus.rap).toFixed(2) +
                                        organisation?.currency?.code}
                                    </p>
                                    <p class="fs-13 text-dark fw-bold mb-0">
                                      {invoiceStatus.payment_account?.code ===
                                        undefined &&
                                      invoiceStatus.payment_account?.name ===
                                        undefined
                                        ? ""
                                        : invoiceStatus.payment_account.code +
                                          " - " +
                                          invoiceStatus.payment_account.name}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ===
                                        undefined &&
                                      invoiceStatus?.chequeId === undefined
                                        ? ""
                                        : invoiceStatus.banquePaymentOption ===
                                          null
                                        ? ""
                                        : invoiceStatus.banquePaymentOption +
                                          (invoiceStatus.chequeId === null ||
                                          invoiceStatus.chequeId === ""
                                            ? ""
                                            : " - " + invoiceStatus.chequeId)}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ==
                                        "effet" && invoiceStatus.effetId}
                                    </p>
                                    {invoiceStatus?.banquePaymentOption && (
                                      <p className="fs-13 text-dark fw-bold mb-0">
                                        mode de paiement :{" "}
                                        {invoiceStatus?.banquePaymentOption}
                                      </p>
                                    )}{" "}
                                    {invoiceStatus.status !== 1 && (
                                      <>
                                        <p>Recu de paiement :</p>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <button
                                            className="btn btn-sm " style={{backgroundColor:"#f1461d", color:"white"}}
                                            onClick={() =>
                                              downloadRecu(invoiceStatus.id)
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              download
                                            </span>
                                          </button>

                                          <input
                                            type="file"
                                            onChange={handleFileChange}
                                            id="fileInput"
                                            className="d-none"
                                            accept="image/*, .pdf"
                                          />
                                          <button
                                            className="btn btn-sm btn-warning"
                                            onClick={() =>
                                              document
                                                .getElementById("fileInput")
                                                .click()
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              publish
                                            </span>
                                          </button>

                                          <button
                                            className="btn btn-sm btn-success"
                                            onClick={() =>
                                              handleSubmit(invoiceStatus.id)
                                            }
                                            hidden={!selectedFile}
                                          >
<span class="material-symbols-outlined">
save
</span>
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      }

                      if (invoiceStatus.status.name === "Payé") {
                        console.log(invoiceStatus);
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                    <p class="fs-13 text-dark fw-bold mb-0">
                                      {invoiceStatus.payment_account?.code ===
                                        undefined &&
                                      invoiceStatus.payment_account?.name ===
                                        undefined
                                        ? ""
                                        : invoiceStatus.payment_account.code +
                                          " - " +
                                          invoiceStatus.payment_account.name}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ===
                                        undefined &&
                                      invoiceStatus?.chequeId === undefined
                                        ? ""
                                        : invoiceStatus.banquePaymentOption +
                                            " - " +
                                            invoiceStatus.chequeId ===
                                          null
                                        ? ""
                                        : invoiceStatus.chequeId}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ==
                                        "effet" && invoiceStatus.effetId}
                                    </p>
                                    {invoiceStatus?.banquePaymentOption && (
                                      <p className="fs-13  text-dark fw-bold mb-0">
                                        mode de paiement :{" "}
                                        {invoiceStatus?.banquePaymentOption}
                                      </p>
                                    )}{" "}
                                    {invoiceStatus.status !== 1 && (
                                      <>
                                        <p>Recu de paiement :</p>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <button
                                            className="btn btn-sm" style={{backgroundColor:"#f1461d", color:"white"}}
                                            onClick={() =>
                                              downloadRecu(invoiceStatus.id)
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              download
                                            </span>
                                          </button>

                                          <input
                                            type="file"
                                            onChange={handleFileChange}
                                            id="fileInput"
                                            className="d-none"
                                            accept="image/*, .pdf"
                                          />
                                          <button
                                            className="btn btn-sm btn-warning"
                                            onClick={() =>
                                              document
                                                .getElementById("fileInput")
                                                .click()
                                            }
                                          >
                                            <span class="material-symbols-outlined">
                                              publish
                                            </span>
                                          </button>

                                          <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() =>
                                              handleSubmit(invoiceStatus.id)
                                            }
                                            hidden={!selectedFile}
                                          >
<span class="material-symbols-outlined">
save
</span>
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      } else {
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="offcanvas offcanvas-bottom addProductCanvas"
          tabIndex="-1"
          id="offcanvasBottom"
          aria-labelledby="offcanvasBottomLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasBottomLabel">
              Renseigner le produit à ajouter.
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i class="fe fe-x fs-18"></i>
            </button>
          </div>
          <div class="offcanvas-body">
            <div id="all-fields-are-required">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Tous les champs sont obligatoire !
                </span>
              </div>
              <br />
            </div>

            <div id="warning-product-already-exists">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Le produit déja exist !
                </span>
              </div>
              <br />
            </div>

            <div id="qty-is-higher">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> L'article choisie est en rupture
                  de stock
                </span>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceDepenseDetails;
